<section class="pagenot-found-section d-flex-center flex-column min-vh-100">
    <h2>404</h2>
    <h4>Page not found</h4>
    <br>
    <a routerLink="/dashboard" nz-button nzType="primary">Back to home</a>
</section>
